import { render, staticRenderFns } from "./MemberTalkSetting.vue?vue&type=template&id=40176088&scoped=true&"
import script from "./MemberTalkSetting.vue?vue&type=script&lang=js&"
export * from "./MemberTalkSetting.vue?vue&type=script&lang=js&"
import style0 from "./MemberTalkSetting.vue?vue&type=style&index=0&id=40176088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40176088",
  null
  
)

export default component.exports